export default __webpack_public_path__ + "static/static-page-banner-d-cd21fbf788fc488508ad38b1cbcd4687.jpg";